'use client'

import Image from 'next/image'
import Link from 'next/link'
import { useState } from 'react'
import type { IBlog } from '@/constants/blogs'
import Author from './author'

export function BlogRow({ title, summary, name, date, avatar, cover, href }: IBlog & { href: string }) {
  const [isLoading, setIsLoading] = useState(true)
  const [hasError, setHasError] = useState(false)
  const imageUrl = `https://cdn.aitubiao.com/static/images/itubiao/blogs/cover/${encodeURIComponent(cover)}`
  const defaultImage = 'https://cdn.aitubiao.com/static/images/itubiao/blogs/cover/default.png'

  return (
    <Link href={href} className="block">
      <article className="mx-auto h-57 w-full rounded-2xl border bg-[#ffffff] p-6 transition duration-300 hover:shadow-simple">
        <div className="flex h-full gap-6">
          <div className="flex h-full flex-1 flex-col gap-5">
            <h1 className="text-xl font-bold leading-tight text-foreground">{title}</h1>

            <p
              className="flex-1 overflow-hidden text-ellipsis pr-2 text-base text-secondary"
              style={{ display: '-webkit-box', WebkitLineClamp: 3, WebkitBoxOrient: 'vertical' }}
            >
              {summary}
            </p>

            <Author name={name} date={date} avatar={avatar} />
          </div>

          <div className="relative order-first aspect-video h-full flex-shrink-0 overflow-hidden rounded-xl bg-gray-200 md:order-last">
            {isLoading && (
              <div className="absolute inset-0 animate-pulse bg-gray-300">
                <div className="h-full w-full bg-gradient-to-r from-transparent via-gray-200 to-transparent" />
              </div>
            )}
            <Image
              src={hasError ? defaultImage : imageUrl}
              alt={title}
              fill
              sizes="(min-width: 768px) 280px, 40vw"
              className={`object-cover transition-opacity duration-300 ${isLoading ? 'opacity-0' : 'opacity-100'}`}
              onLoad={() => {
                setIsLoading(false)
                setHasError(false)
              }}
              onError={() => {
                setIsLoading(false)
                setHasError(true)
              }}
            />
          </div>
        </div>
      </article>
    </Link>
  )
}
